import React, { useState } from "react";
import "./HeroSection.css";
import athleteImage from "../assets/atheletehome.png";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const TRUSTED_NAMES = [
  {
    category: "Pro Kabaddi League",
    people: [
      { name: "Mithin", detail: "Bengal Warriors & Bengaluru Bulls" },
      //{ name: "Sukesh", detail: "" },
      { name: "Guhan", detail: "Bengal Warriors" },
      { name: "Chandra", detail: "Bengaluru Bulls" },
      { name: "Preetham", detail: "Patna Pirates" },
     // { name: "Shashank", detail: "Khelo India & 38th National Games" },
    ],
  },
  {
    category: "Content Creators and Fitness Models",
    people: [
      { name: "Indian Biker Rally", detail: "insta content creator" },
      { name: "Chirag", detail: "insta fitness model" },
      // { name: "Shraddha", detail: "insta fitness coach and athlete" },
      // { name: "Manya", detail: "insta fitness influencer" }
   ]
  },
  {
    category: "Represented India",
    people: [
      {name: "Puttaraj", detail: "represented India 65+ times in badminton, Ekalavya award winner " },
      { name: "Naija", detail: "represented India in international world school games " },
    ],
  },
    {
    category: "organizations and Film industry",
    people: [
      {  name: "Kolkata Thunderbolts",detail: "volleyball" },
      {  name: "basuma kodagu",detail: "kantara and other movies " },
      
    ],
  },
];

const HeroSection = () => {
  const [showTrustedList, setShowTrustedList] = useState(false);

  return (
    <>
      <Helmet>
        <title>Best Physiotherapy in Udupi | No. 1 Sports Science & Rehab Center</title>
        <meta
          name="description"
          content="Aikyam Sports Science is the best physiotherapy and No. 1 sports rehab center in Udupi. Top-rated strength and conditioning for Udupi, Manipal, and Mangalore."
        />
        <meta
          name="keywords"
          content="best physiotherapy in udupi, no 1 rehab center udupi, best strength and conditioning udupi, top rated sports science udupi, best fitness centre manipal, No 1 athlete recovery mangalore, best physiotherapist"
        />
        <link rel="canonical" href="https://aikyamsports.com/" />

        {/* Open Graph */}
        <meta property="og:title" content="Best Physiotherapy in Udupi | No. 1 Sports Science & Rehab Center" />
        <meta
          property="og:description"
          content="Udupi's No. 1 Sports Science and Fitness Centre combining cutting-edge technology with the best physiotherapy, recovery, and strength & conditioning."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://aikyamsports.com/" />
        <meta property="og:image" content="https://aikyamsports.com/logo11.png" />
        <meta property="og:site_name" content="Aikyam Sports Science" />
      </Helmet>

      <div className="hero-container">
        <div className="hero-ellipse-left" />
        <div className="hero-ellipse-right" />

        <div className="hero-text">
          <div className="hero-heading">
            <h1 className="hero-title-normal">Empowering</h1>
            <h1 className="hero-title-athletes">Athletes</h1>
            <h2 className="hero-subtitle">With Best Sports Science</h2>
          </div>

          <div className="hero-image mobile-only">
            <div className="image-glow" />
            <img src={athleteImage} alt="Athlete" className="athlete-img" />
          </div>

          <p className="hero-description">
            Welcome to AIKYAM Sports Science, ranked as one of the best physiotherapy centers in Udupi and the No. 1 Sports Science Center. We combine cutting-edge technology with the region's best strength and conditioning (S&C), clinical nutrition, and top-rated sports psychology to elevate athlete performance across Udupi, Manipal, and Mangalore. <br /><br />
            As Udupi's leading sports science center, we are proud recipients of the NIDHI - EIR and NIDHI - PRAYAS grants from the Government of India, recognizing our commitment to innovation and excellence in sports science.
          </p>

          <div className="hero-buttons">
            <Link to="/fitness" className="link-no-underline">
              <button className="hero-button-primary" aria-label="Start your fitness journey at the best clinic in Udupi">Start Your Journey</button>
            </Link>
            <a href="#premium-services">
              <button className="hero-button-outline" aria-label="Explore top rated Aikyam fitness programs">Explore Programs</button>
            </a>
          </div>
        </div>

        {/* 👇 Image on right side for desktop */}
        <div className="hero-image desktop-only">
          <div className="image-glow" />
          <img src={athleteImage} alt="Athlete training at Aikyam Sports Science" className="athlete-img" />
          <div className="info-box right-shoulder">
            1300+
            <br />
            Positive reviews
          </div>
          <div className="info-box left-arm">
            20+
            <br />
            Coaches
          </div>
          <div className="info-box left-leg">
            200+
            <br />
            Successful Rehabilitation
          </div>
          <div className="info-box right-leg">
            600+
            <br />
            Athletes Impacted
          </div>
        </div>

        <div className="hero-stats-section" aria-label="Aikyam Sports Science achievements">
          <div className="stat-box">
            <h2>
              <span className="highlight">98%</span> Client Satisfaction
            </h2>
            <p>Our Members Love Their Results And Experience</p>
          </div>
          <div className="divider" />
          <div className="stat-box">
            <h2>
              <span className="highlight">+5</span> Years Of Experience
            </h2>
            <p>Trust In Our Proven Track Record Of Transforming</p>
          </div>
          <div className="divider" />
          <div className="stat-box">
            <h2>
              <span className="highlight">+800</span> Active Members
            </h2>
            <p>Join Our Thriving Community</p>
          </div>
          <div className="divider" />
          <div className="stat-box">
            <h2>
              <span className="highlight">24/7</span> Support Available
            </h2>
            <p>Expert Assistance Whenever You Need It</p>
          </div>
        </div>

        {/* 🌟 Trust Badge — click to reveal names 🌟 */}
        <button
          type="button"
          className="hero-trust-badge-bottom"
          onClick={() => setShowTrustedList(true)}
          aria-haspopup="dialog"
          aria-expanded={showTrustedList}
        >
          <span className="trust-star">★</span>
          <span className="trust-text">
            Trusted by <strong>Pro Kabaddi League Players</strong>, <strong>Top Fitness Models</strong>,{" "}
            <strong>Content Creators</strong> &amp; <strong>Athletes Who Represented India</strong>
          </span>
        </button>

        {showTrustedList && (
          <div
            className="trusted-modal-overlay"
            role="dialog"
            aria-modal="true"
            aria-label="People who trust Aikyam Sports Science"
            onClick={() => setShowTrustedList(false)}
          >
            <div
              className="trusted-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                className="trusted-modal-close"
                onClick={() => setShowTrustedList(false)}
                aria-label="Close"
              >
                &times;
              </button>

              <h3 className="trusted-modal-title">
                <span className="trust-star">★</span> Trusted By
              </h3>

              <div className="trusted-modal-grid">
                {TRUSTED_NAMES.map((group) => (
                  <div className="trusted-group" key={group.category}>
                    <h4 className="trusted-group-title">{group.category}</h4>
                    <ul className="trusted-group-list">
                      {group.people.map((person) => (
                        <li key={person.name}>
                          <span className="trusted-name">{person.name}</span>
                          {person.detail && (
                            <span className="trusted-detail"> — {person.detail}</span>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

      </div>
    </>
  );
};

export default HeroSection;